import React from "react";
import { Container, Row, Col, Card, ListGroup, Button, Image, Table } from "react-bootstrap";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram, FaComment, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useState } from "react";
import Footer from './footer';
import { motion } from "framer-motion";
import LatestUpdates from "./latestupdates";
import "./img.css";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const VisaTable = () => (
    <div className="mt-4 table-responsive">
        <Table bordered hover className="table">
            <thead className="table">
                <tr>
                    <th>TYPE</th>
                    <th>DESCRIPTION</th>
                    <th>STAY</th>
                    <th>COST</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><strong>Skilled Work Regional (Provisional) visa – Main applicant</strong></td>
                    <td>This is a provisional visa. It is for skilled workers who want to live and work in regional Australia.</td>
                    <td>You can stay in Australia for 5 years</td>
                    <td>From AUD4,045</td>
                </tr>
                <tr>
                    <td><strong>Skilled Work Regional (Provisional) visa – Subsequent Entrant</strong></td>
                    <td>This visa is for a member of the family unit of someone who holds a Skilled Work Regional (Provisional) visa (subclass 49).</td>
                    <td>Until the visa that your family member holds ends.</td>
                    <td>From AUD4,045</td>
                </tr>
            </tbody>
        </Table>
    </div>
);


const ContentSection = () => (
    <Container className="mt-4">
        <Row>
            <Col md={8}>
                <p className="mt-3">
                    A visa for skilled people nominated by a state or territory government to live and work in regional Australia.
                </p>
                <h4>BASIC ELIGIBILITY</h4>
                <p>You must:</p>
                <ul>
                    <li>be nominated to apply by a state or territory government agency, or an eligible relative must sponsor you</li>
                    <li>have an occupation on a relevant skilled occupation list</li>
                    <li>have a suitable skills assessment for the occupation</li>
                    <li>be invited to apply</li>
                    <li>satisfy the points test</li>
                </ul>
                <br />
                <VisaTable />
                <h4>NSW</h4>
                <p>In the recent past, the NSW has been very generous at providing state nominations for
                    491 Visa. The nomination requirements were not that hard for someone living in the
                    regional area of NSW. Here below are some use full links that provide the latest information about the NSW.</p>
                <a href="https://www.nsw.gov.au/working-and-business" className="text-decoration-none">NSW State Nomination</a><br /><br />
                <h4>Victoria</h4>
                <p>Victoria has opened state nomination for a few number of occupations. The link below gives the latest
                    information about 491 Victoria state nomination.</p>
                <a href="https://liveinmelbourne.vic.gov.au/migrate/skilled-migration-visas/491" className="text-decoration-none">491 Victoria Nomination</a><br /><br />
                <h4>Canberra</h4>
                <p>Canberra Matrix latest information</p>
                <a href="http://www.canberrayourfuture.com.au/portal/migrating/AATicle/skilled-visa-act-nomination/" className="text-decoration-none">Canberra 491 Information.</a><br /><br />
                <h4>Tasmania</h4>
                <p>Tasmania 491 Visa Requirements</p>
                <a href="https://www.migration.tas.gov.au/skilled_migrants/skilled_regional" className="text-decoration-none">Tasmania 491 Information</a><br /><br />
                <h4>Western Australia</h4>
                <p>Western Australia 491 Visa News</p>
                <a href="https://migration.wa.gov.au/our-services-support/state-nominated-migration-program" className="text-decoration-none">491 WA News</a><br /><br />
                <h4>QLD</h4>
                <p>Queensland 491 state nomination News</p>
                <a href="https://migration.qld.gov.au/visa-options/skilled-visas/skilled-workers-living-in-queensland" className="text-decoration-none">QueensLand 491 Visa News</a><br /><br />
                <h4>South Australia</h4>
                <p>South Australia 491 Visa News</p>
                <a href="https://www.migration.sa.gov.au/visa-options/skilled-visas/skilled-work-regional-visa#nav-conditions/" className="text-decoration-none">South Australia 491 Nomination Information</a><br /><br />
                <h4>Northern Territory</h4>
                <p>Northern Territory 491 Visa nomination</p>
                <a href="https://theterritory.com.au/migrate/migrate-to-work/northern-territory-government-visa-nomination/eligibility" className="text-decoration-none" >491 Northern Territory Information</a>
                <br /><br /><br />
              
                <br />
               

            </Col>

            {/* Sidebar Section */}
            <Col md={4}>
                <Card className="p-3 text-center">
                    {/* Bajwa Immigration Image */}
                    <Image
                        src="./img/brand-logo.png"
                        alt="Bajwa Immigration Logo"
                        fluid
                        className="mb-3"
                    />

                    <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
                    <Button variant="danger" className="mb-3"><a href="https://www.youtube.com/embed/uOGAB9oYets">SUBSCRIBE</a></Button>

                    <h6 className="fw-bold">Book Consultation</h6>
                    <Button variant="warning">BOOK CONSULTATION</Button>

                    <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
                    {/* Facebook Embed */}
                    <iframe
                        src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                        width="100%"
                        height="130"
                        style={{ border: "none", overflow: "hidden" }}
                        scrolling="no"
                        frameBorder="0"
                        allowFullScreen
                    ></iframe>

                    {/* Social Media */}
                    <h6 className="fw-bold mt-3">We are also on:</h6>
                    <div className="d-flex justify-content-center gap-3">
                        <FaInstagram size={30} color="#C13584" />
                        <FaTiktok size={30} color="#000" />
                        <FaYoutube size={30} color="crimson" />
                    </div>
                </Card>
            </Col>
        </Row>
    </Container>
);


const RegionalVisa = () => {
    return (
        <>
            <Container className="mt-4">
                <h1 className="fw-bold">Skilled Work Regional Visa (Subclass 491)</h1>

                {/* YouTube Embed Section */}
                <Row className="mt-3">
                    <Col md={8}>
                        <div className="ratio ratio-16x9">
                            <iframe
                                width="100%"
                                height="400"
                                src="https://www.youtube.com/embed/rwEEjSHjqpg"
                                title="YouTube video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </Col>

                    {/* Sidebar - Latest Posts */}
                    <Col md={4}>
                        <Card>
                            <Card.Header className="fw-bold">Latest Posts</Card.Header>
                            <ListGroup variant="flush">
                                <ListGroup.Item><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">   Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                                  <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"className="dropdown-item text-decoration-none"style={{ color: "#22327f" }}target="_blank"rel="noopener noreferrer">Permanent Residence visa (Subclass 191)</a></ListGroup.Item>
                                {/* <ListGroup.Item><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */
                                <ListGroup.Item><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
}
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* Content Section */}
            <ContentSection />


            {/* Floating Feedback Button */}
            <div className="position-fixed bottom-0 stAAT-0 m-3">
            <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
            </div>
            <LatestUpdates />
            <Footer />
        </>
    );
};

export default RegionalVisa;